import React from 'react';
import { Col, Row, Typography } from 'antd';
import { useAuthStore } from '@/store/authStore';
import { canEnterOperatorVendorDirectory, canManageAnyTags } from '@/store/vendorAccess';
import { canEnterTransfers } from '@/store/transferAccess';
import QuickAccessTiles from '@/components/home/QuickAccessTiles';
import RecentTransfersCard from '@/components/home/RecentTransfersCard';
import FailedTransfersCard from '@/components/home/FailedTransfersCard';
import PendingVendorsCard from '@/components/home/PendingVendorsCard';

const { Title, Text, Paragraph } = Typography;

const HomeOverviewPage: React.FC = () => {
  const { user, authorization, currentBusinessUnit } = useAuthStore();
  const name = user?.displayName || user?.email || user?.username;
  const showVendors = Boolean(authorization?.globalAdmin) || canEnterOperatorVendorDirectory(authorization);
  const showTransfers = canEnterTransfers(authorization);
  const showAdHoc = Boolean(authorization?.actions.includes('transfers.adhoc'));
  const showSettings = Boolean(
    authorization?.globalAdmin || authorization?.actions.includes('settings.manage')
  );
  const showTags = canManageAnyTags(authorization);
  const showAreas = showVendors || showTransfers || showAdHoc || showSettings || showTags;

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <Title level={2} style={{ marginBottom: 0 }}>
          {name ? `Welcome, ${name}` : 'Welcome'}
        </Title>
        {currentBusinessUnit?.name && (
          <Text type="secondary" style={{ display: 'block' }}>{currentBusinessUnit.name}</Text>
        )}
        <Paragraph style={{ marginTop: 8, marginBottom: 0 }}>
          Securely exchange files with vendors and track transfers for your business unit.
        </Paragraph>
      </div>
      {showAreas ? (
        <>
          <QuickAccessTiles />
          <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
            {showTransfers && (
              <Col xs={24} lg={8}>
                <RecentTransfersCard />
              </Col>
            )}
            {showTransfers && (
              <Col xs={24} lg={8}>
                <FailedTransfersCard />
              </Col>
            )}
            {showVendors && (
              <Col xs={24} lg={8}>
                <PendingVendorsCard />
              </Col>
            )}
          </Row>
        </>
      ) : (
        <Paragraph>
          You don't have access to any Data Exchange areas yet. Ask your manager to add you to the right access group.
        </Paragraph>
      )}
    </div>
  );
};

export default HomeOverviewPage;
